import { render, staticRenderFns } from "./initials.vue?vue&type=template&id=5ca6d7f7&scoped=true&"
import script from "./initials.vue?vue&type=script&lang=js&"
export * from "./initials.vue?vue&type=script&lang=js&"
import style0 from "./initials.vue?vue&type=style&index=0&id=5ca6d7f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca6d7f7",
  null
  
)

component.options.__file = "initials.vue"
export default component.exports